module.exports = "/assets/b5badf1183f98a0928049010a2086a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4H.png
// module id = 2164
// module chunks = 0